import './spinner.css';

export default function Spinner() {
  return (
    <div className="spinner-overlay">
      <div className="spinner-container">
        <div className="modern-loader">
          <div className="loader-ring"></div>
          <div className="loader-ring"></div>
          <div className="loader-ring"></div>
        </div>
        <div className="loading-text">
          <span>C</span>
          <span>a</span>
          <span>r</span>
          <span>r</span>
          <span>e</span>
          <span>g</span>
          <span>a</span>
          <span>n</span>
          <span>d</span>
          <span>o</span>
          <span>&nbsp;</span>
          <span>d</span>
          <span>a</span>
          <span>d</span>
          <span>o</span>
          <span>s</span>
        </div>
      </div>
    </div>
  );
}